import React, { useCallback, useState, useEffect } from "react";
import { DEFAULT_OPTION } from "../constants/app.constants";

interface DropdownListInterface {
  id: string;
  isMultipleList?: boolean;
  data?: string;
  dropDownData?: any; //This can be data from api or static data
  rowAndFieldIndex?: string;
  multipleSelectedId?: Array<string>;
  style?: React.CSSProperties;
  defaultOption?: string;
  selectedID?: string;
  className?: string;
  onChange: (
    id: string,
    updatedValue?: string[] | string | Date | undefined,
    updatedName?: string,
    parsedObj?: string,
    rowAndFieldIndex?: string
  ) => void;
}
interface alloptionsObjType {
  id: string;
  status_flag: string;
  sprint_status: string;
  name: string;
}

const DropdownList: React.FC<DropdownListInterface> = (props) => {
  const [updatedValue, setUpdatedValue] = useState(props.data);
  const [updatedName, setUpdatedName] = useState("");
  const [parssedObject, setParssedObject] = useState("");

  useEffect(() => {
    if (!props.isMultipleList && updatedValue !== DEFAULT_OPTION) {
      props.onChange(
        props.id,
        updatedValue,
        updatedName,
        parssedObject,
        props.rowAndFieldIndex
      );
    } else {
      props.onChange(props.id, updatedValue);
    }
  }, [updatedValue, updatedName]);

  const onChangeDropDown = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (props.isMultipleList === true) {
      const options = e.target.options;
      const value: string[] = [];
      for (let i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
          value.push(options[i].id);
        }
      }
      props.onChange(props.id, value);
    } else {
      const selectedIndex = e.target.value;

      if (e.target.value !== DEFAULT_OPTION) {
        let parsedObj;
        if (props.dropDownData.apiData) {
          parsedObj = props.dropDownData.apiData[selectedIndex];
        } else {
          parsedObj = props.dropDownData[selectedIndex];
        }

        setUpdatedValue(parsedObj.id);
        setUpdatedName(parsedObj.name);
        setParssedObject(parsedObj);
      } else {
        setUpdatedValue(e.target.value);
        props.onChange(props.id, e.target.value);
      }
    }
  };

  const isSelectedInMultiple = useCallback(
    (currentId: string) => {
      const { multipleSelectedId } = props;
      if (multipleSelectedId) {
        return multipleSelectedId.includes(currentId);
      }
    },
    [props.multipleSelectedId]
  );

  const {
    id,
    dropDownData,
    style,
    defaultOption,
    selectedID,
    className,
    isMultipleList,
  } = props;

  const alloptions = dropDownData;
  let alloptionlist;
  if (alloptions && alloptions.apiData) {
    alloptionlist = alloptions.apiData.map(
      (alloptionsObj: alloptionsObjType, index: number) => (
        <option
          id={alloptionsObj.id}
          key={alloptionsObj.id}
          value={index}
          selected={alloptionsObj.id === selectedID}
          className={
            alloptionsObj.status_flag === "1" ||
            (alloptionsObj.sprint_status &&
              alloptionsObj.sprint_status === "close")
              ? "red-color-class"
              : "default-color-class"
          }
        >
          {alloptionsObj.name}
        </option>
      )
    );
  } else if (alloptions && alloptions[0]) {
    if (isMultipleList) {
      alloptionlist = alloptions.map(
        (alloptionsObj: alloptionsObjType, index: number) => (
          <option
            id={alloptionsObj.id}
            key={alloptionsObj.id}
            value={index}
            selected={isSelectedInMultiple(alloptionsObj.id)}
          >
            {alloptionsObj.name}
          </option>
        )
      );
    } else {
      alloptionlist = alloptions.map(
        (alloptionsObj: alloptionsObjType, index: number) => (
          <option
            id={alloptionsObj.id}
            key={alloptionsObj.id}
            value={index}
            selected={alloptionsObj.id === selectedID}
            className={
              alloptionsObj.status_flag === "1"
                ? "red-color-class"
                : "default-color-class"
            }
          >
            {alloptionsObj.name}
          </option>
        )
      );
    }
  }

  return (
    <div>
      {isMultipleList ? (
        <select
          id={id}
          onChange={onChangeDropDown}
          style={style}
          className={className}
          multiple={true}
        >
          {alloptionlist}
        </select>
      ) : defaultOption && defaultOption !== "null" ? (
        <select
          id={id}
          onChange={onChangeDropDown}
          style={style}
          className={className}
        >
          <option id="all" value={DEFAULT_OPTION}>
            {defaultOption}
          </option>
          {alloptionlist}
        </select>
      ) : (
        <select
          id={id}
          onChange={(e) => onChangeDropDown(e)}
          style={style}
          className={className}
        >
          {alloptionlist}
        </select>
      )}
    </div>
  );
};
export default DropdownList;
